import React, { useEffect, useState } from "react";
import { useAuth } from "../contexts/AuthContext";
import { useNavigate } from "react-router-dom";

const Login = () => {
  const { user, isAuthenticated, isLoading } = useAuth();
  const navigate = useNavigate();
  const [redirecting, setRedirecting] = useState(false);

  useEffect(() => {
    console.log("Login component - Auth status:", {
      isAuthenticated,
      user: user?.email,
      isLoading,
    });

    // If user is already authenticated, redirect to payment
    if (isAuthenticated && user?.email) {
      console.log(
        "User already authenticated, redirecting to payment with email:",
        user.email
      );
      navigate(
        `/payment?user_email=${encodeURIComponent(
          user.email
        )}&user_id=${encodeURIComponent(user.id)}`
      );
      return;
    }

    // If not loading and not authenticated, redirect to FI login
    if (!isLoading && !isAuthenticated) {
      setRedirecting(true);
      const returnUrl = encodeURIComponent(`${window.location.origin}/payment`);
      const redirectUrl = `https://intelligence.fozzil.in/login?redirect=${returnUrl}`;

      console.log("Redirecting to FI login:", redirectUrl);

      // Add delay to show loading state
      setTimeout(() => {
        window.location.href = redirectUrl;
      }, 1000);
    }
  }, [isAuthenticated, user, isLoading, navigate]);

  // Show different states based on auth status
  if (isLoading) {
    return (
      <div className="bg-white text-black min-h-screen py-8 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500 mx-auto mb-4"></div>
          <p className="text-gray-600">Checking authentication...</p>
        </div>
      </div>
    );
  }

  if (isAuthenticated && user) {
    return (
      <div className="bg-white text-black min-h-screen py-8 flex items-center justify-center">
        <div className="text-center">
          <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg
              className="w-8 h-8 text-green-600"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M5 13l4 4L19 7"
              ></path>
            </svg>
          </div>
          <p className="text-green-600 font-medium">
            Welcome back, {user.email}!
          </p>
          <p className="text-gray-600">Redirecting to payment...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white text-black min-h-screen py-8 flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500 mx-auto mb-4"></div>
        <p className="text-gray-600">
          {redirecting
            ? "Redirecting to FOZZIL Intelligence login..."
            : "Preparing login..."}
        </p>
        <p className="text-sm text-gray-500 mt-2">
          You'll return here after signing in
        </p>
      </div>
    </div>
  );
};

export default Login;
